import React from 'react';

interface LicenseTrialSegmentProps {
  status: 'trialing' | 'expired';
}

/**
 * The small pill nested inside the license chip (Design A, dark-grey
 * inner-pill variant -- ChipInnerGrey.dc.html). Status logic/icons carried
 * over from Design C's exploration (ChipSegmented.dc.html /
 * ChipLifecycle.dc.html): the clock icon on 'trialing' isn't in either
 * original mockup (which only showed plain "Trial" text), added on request,
 * reusing the exact clock icon the same design file already uses for its
 * "expiring soon" lifecycle state so it stays visually consistent with the
 * design system's own icon choice rather than introducing a new one. Only
 * the 'expired' icon is tinted red; both icons otherwise match the pill's
 * own neutral text color via currentColor.
 */
const LicenseTrialSegment: React.FC<LicenseTrialSegmentProps> = ({ status }) => {
  if (status === 'expired') {
    return (
      <span className='license-chip-inner-pill'>
        <svg
          width='11'
          height='11'
          viewBox='0 0 24 24'
          aria-hidden='true'
          className='license-chip-expired-icon'
        >
          <path d='M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8' />
        </svg>
        Expired
      </span>
    );
  }

  return (
    <span className='license-chip-inner-pill'>
      <svg
        width='11'
        height='11'
        viewBox='0 0 24 24'
        aria-hidden='true'
        className='license-chip-trial-icon'
      >
        <path d='M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8m.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z' />
      </svg>
      Trial
    </span>
  );
};

export default LicenseTrialSegment;
